<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import moment from "moment";

export default {
  data() {
      return {
        moment: moment,
      }
  },
  props: {
    variant: {
      type: String,
      required: false
    },
    list: {
      // type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: true,
    },
    prevSelectedItem: {
      type: String,
      required: true
    },
    setSelectedItems: {
      type: Function,
      required: true
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    Container, Draggable
  },
  methods: {
    getChildPayload(itemIndex, list) {
      return list[itemIndex]
    },
    async onDrop(event, list) {
      let updatedList = await this.applyDrag(list, event)
      this.topbarControls.onDragUpdateFn(list, updatedList);
    },
    async applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }
      return result
    },
    async switchItem(val) {
      this.setSelectedItems(val);
    }
  }
};
</script>
<template>
    <div v-if="list && list.length">
      <Container 
          tag="ul"
          class="list-unstyled chat-list"
          drag-handle-selector=".draggable-item-trigger"
          lock-axis="y"
          :drag-begin-delay="0"
          :get-child-payload="itemIndex => getChildPayload(itemIndex, list)"
          @drop="onDrop($event, list)"
      >
          <Draggable 
          v-for="data of list" 
          tag="li" 
          :key="data.id" 
          :class="{ active: data.id == selectedItem.id }"
          >
          <a href="javascript: void(0);" @click="switchItem(data)"
                  :style="data.additionalProp1 ? data.additionalProp1.color == 'Red' 
                  ? 'border-left: 5px solid red' : data.additionalProp1.color == 'Amber' 
                  ? 'border-left: 5px solid #FFB902' : data.additionalProp1.color == 'Green' 
                  ? 'border-left: 5px solid green' : '' : ''">
              <div class="media">
              <div class="media-body overflow-hidden p-2">
                  <p class="text-truncate font-size-16 mb-0 px-2">
                  <i v-if="data.additionalProp1 && 'featured' in data.additionalProp1 && data.additionalProp1.featured || data.featured" class="ri-star-fill mr-2" style="color: gold;"></i>
                  <span :style="'active' in data && !data.active ? data.id !== selectedItem.id ? 'color: gray' : '' : ''">
                  {{ moment(data.title, "YYYY-MM-DD", true).isValid() ? moment(new Date(data.title)).format('DD MMMM, YYYY') : data.title}}
                  </span>
                  </p>
              </div>
              </div>
          </a>
          </Draggable>
      </Container> 
    </div>
    <div v-else>
      <p>No items found!</p>
    </div>
 
</template>

<style lang="scss" scoped>
.chat-list {
li {
    .draggable-item-trigger-container {
    height: 40px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    
    .draggable-item-trigger {
        width: 20px;
        height: 8px;
        border-top: 2px solid #333;
        border-bottom: 2px solid #333;
        margin-right: 16px;
    }
    }

    &:hover,
    &.active {
    .draggable-item-trigger {
        border-top-color: #fff;
        border-bottom-color: #fff;
    }
    }
}
}
</style>